<template>
    <div class="KEditor">
        <Toolbar class="KEditor__Toolbar" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor class="KEditor__Editor" :style="{ height: typeof height == 'number' ? `${height}px` : height }"
            v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"
            @onChange="handleChange" @onDestroyed="handleDestroyed" @onFocus="handleFocus" @onBlur="handleBlur"
            @customAlert="customAlert" @customPaste="customPaste" />
    </div>
</template>

<script>
import axios from 'axios'
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
    name: 'KEditor',
    components: { Editor, Toolbar },
    props: {
        datas: {
            type: [String, Number],
            default() {
                return ''
            }
        },
        dir: {
            type: String,
            default() {
                return '/editor'
            }
        },
        //图片大小
        size: {
            type: Number,
            default: () => 5
        },
        height: {
            type: [Number, String],
            default() {
                return 400
            }
        }
    },
    data() {
        return {
            editorRef: null,
            valueHtml: '',
            toolbarConfig: {},
            editorConfig: {},
            mode: 'default', // 或 'simple'
            headers: { 
                'tenant-id': localStorage.getItem("wwmxt_Rootid"),
                'token': localStorage.getItem("ai_Token") 
            }
        }
    },
    beforeDestroy() {
        if (this.editor == null) return
        this.editor.destroy()
    },
    created() {
        this.valueHtml = this.datas;
        this.editorConfig = {
            placeholder: '请输入内容...',
            MENU_CONF: {
                uploadImage: { //上传图片
                    customUpload: async (file, insertFn) => {
                        this.customUploadHandle(file, insertFn);
                    }
                },
                uploadVideo: {
                    customUpload: async (file, insertFn) => {
                        this.customUploadHandle(file, insertFn);
                    }
                }
            }
        }
    },
    methods: {
        handleCreated(editor) {
            this.editorRef = editor
        },
        handleChange(editor) {
            this.$emit('update:datas', this.valueHtml)
        },
        handleDestroyed(editor) {

        },
        handleFocus(editor) {

        },
        handleBlur(editor) {

        },
        customAlert(editor) {

        },
        customPaste(editor) {

        },
        customUploadHandle(file, insertFn){
            if (file.size > (this.size * 1024 * 1024)) {
                this.$message.warning(`您上传的${file.name}，该文件大于${this.size}M，请您重新上传。`);
                return false;
            }

            let FormDatas = new FormData();
            FormDatas.append("file", file);
            axios({
                method: "post",
                url: this.GetAiUrl() + "/upload",
                headers: this.headers,
                data: FormDatas
            }).then( (response)=> {
                if(response.data.code ==  0 && response.data.data){
                    insertFn(response.data.data);
                }
            }).catch( (error)=> {
                console.error('error', error)
            })
        }
    }
}
</script>
<style scoped lang="scss">
.KEditor {
    width: 100%;
    border: 1px solid #ccc;

    .KEditor__Toolbar {
        border-bottom: 1px solid #ccc
    }

    .KEditor__Editor {
        overflow-y: hidden;
    }
}
</style>